"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var fetchImage = function fetchImage(image, imageSrc) {
  return new Promise(function (resolve, error) {
    image.src = imageSrc; // eslint-disable-line no-param-reassign
    image.onload = resolve; // eslint-disable-line no-param-reassign
    image.onerror = error; // eslint-disable-line no-param-reassign
  });
};

exports.default = fetchImage;